// import ReactDOM from 'react-dom';
// import {loadDOMComponent} from "../../helpers";
// import {AppContextProvider} from "../../Services/AppContext";
// import {TreatmentContextProvider} from "../../Services/TreatmentContext";
// import Treatment from "./Treatment";
// import {store} from "../../store/store";
// import {Provider} from "react-redux";
//
// loadDOMComponent({
//     selector: 'react-treatment',
//     callback: ({container, context, props}) => {
//
//         const patientId = container.getAttribute('patientId');
//         const workplaceId = container.getAttribute('workplaceId');
//         const loggedUserId = container.getAttribute('loggedUserId');
//         const caseId = container.getAttribute('caseId');
//         const openMedicalReport = container.getAttribute('openMedicalReport');
//         const openMeddiDiabetes = container.getAttribute('openMeddiDiabetes');
//         const isTreatment = container.getAttribute('isTreatment');
//
//         ReactDOM.render(
//             <Provider store={store}>
//                 <AppContextProvider {...context}>
//                     <TreatmentContextProvider values={{ openMedicalReport: Boolean(openMedicalReport), openMeddiDiabetes: Boolean(openMeddiDiabetes), isTreatment: Boolean(isTreatment)}}>
//                         <Treatment patientId={patientId} workplaceId={workplaceId} caseId={caseId} loggedUserId={loggedUserId}/>
//                     </TreatmentContextProvider>
//                 </AppContextProvider>
//             </Provider>,
//             container
//         );
//     }
// })
